<!--(expanded)="expanded($event)"-->
<div class="sop-modal full-height " (window:resize)="onResize($event)">
    <div *ngIf='isDesktop' class="sop-top border-0 text-center">
        <div class="sop-close">
            <button type="button" class="close" (click)="closeWindow(confirmationSOP)">
                <!-- <span aria-hidden="true">&times;</span> -->
            </button>
        </div>
        <div class="d-flex justify-content-between">
            <div class="sop-desc">
                <h4 class="sop-title modal-title w-100 sticky"> {{((done)?'E_LEARNING.RESULT':'') | translate | labelSanitizer}}{{(done)? ':' : ''}} {{sopDetail.title | translate | labelSanitizer}}</h4>
                <span class="sop-ward">{{formdata.ward.wardName | translate | labelSanitizer}}</span>
            </div>
            <div class="sop-categories">
                <div class="d-flex justify-content-around align-items-baseline px-5">
                    <span>{{formdata.department.departmentName | translate | labelSanitizer}}</span>
                    <span class="specs-center">{{formdata.category.categoryName | translate | labelSanitizer}}</span>
                    <span *ngIf="showProfessionalSubcategory">{{formdata.subCategoryName | translate | labelSanitizer}}</span>
                </div>
                <div *ngIf="swappedSteps" class="swapped-box mt-1"><!--<img src="assets/icons/icon-warning-outline.svg" class="mr-4 image-edit">--><p class="m-0 swapped-text">{{ 'SOP_OBSERVATION.SWAPPED_STEPS' | translate }}</p></div>
            </div>
        </div>
    </div>

    <div class="modal-body ui-dialog-fixed flexDirectionColumn bgGray full-height ">
        <div class="image-container-fixedsize justify-content-md-start justify-content-center">

            <div class="d-flex justify-content-center image-div-scroll">
                <div class="row m-0 col-12 card-holder mr-0" #cardHolder>
                    <ng-container *ngFor="let step of sopStep; let i = index">
                        <div class="card card-strip" #card *ngIf="step.stepType" [class.mutli-step-start-image]='step.stepType'>
                            <div *ngIf="i == 0" class="start-image d-flex align-items-center"></div>
                            <div *ngIf="i == sopStepLength" class="start-image-end d-flex align-items-center">
                            </div>
                            <div class="card-task" id="sop-step-{{i + 1}}" (click)="showStep(i, step)">
                                <div class="card-task-media" [ngClass]="(!showStepList[i])?'opacity':''">
                                    <!-- <div class="multi-step-image-overlay"></div> -->
                                    <img class="card-img-top multi-step-image-overlay"
                                    [ngClass]="(step.stepImage)?'svg':'no-image'"
                                    [src]="(step.stepImage)?layoutService.serverUrl+step.stepImage:'assets/img/fallback-img.png'"
                                    (error)="errImg($event)"
                                    alt="SOP">

                                    <span class="multiImage"></span>
                                </div>
                                <div class="card-task-content d-flex align-items-center">
                                    <p class="card-task-desc card-text">
                                        {{step.stepName | translate | labelSanitizer}}</p>
                                </div>

                            </div>
                        </div>
                        <ng-template [ngIf]="!step.stepType || showStepList[i]">
                            <div class="card card-strip" #card *ngFor="let stepCards of step.stepCards; let j = index" [class.mutli-step-sub-cards]='step.stepType'>
                                <div *ngIf="i == 0 && !step.stepType" class="start-image d-flex align-items-center">
                                </div>
                                <div *ngIf="i == sopStepLength && !step.stepType" class="start-image-end d-flex align-items-center">
                                </div>
                                <div class="card-task" id="sop-step-{{i + 1}}" (click)="selectStep(i,j,step.stepType)" [ngClass]="(!seletedSteps[i] || !seletedSteps[i][j])?'':'selected'">
                                    <div class="d-flex justify-content-center icon-middle" *ngIf="done && stepCards.hygieneRelevantStep &&  ( !seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j]))">
                                        <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-down.svg" />
                                    </div>
                                    <div class="d-flex justify-content-center icon-middle" *ngIf="done && stepCards.hygieneRelevantStep &&  ( ( seletedSteps[i] && seletedSteps[i][j]))">
                                        <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-up.svg" />
                                    </div>
                                    <div class="card-task-media" [ngClass]="
                                    (
                                        (!seletedSteps[i] || !seletedSteps[i][j]) || 
                                        (
                                            (done && stepCards.hygieneRelevantStep &&  ( !seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j]))) ||
                                            (done && stepCards.hygieneRelevantStep &&  ( ( seletedSteps[i] && seletedSteps[i][j])))
                                        )
                                    ) ? 'opacity':''">
                                        <img class="card-img-top" [ngClass]="(stepCards.stepImage)?'svg':'no-image'" [src]="(stepCards.stepImage)?layoutService.serverUrl+stepCards.stepImage:'assets/img/fallback-img.png'"
                                        (error)="errImg($event)"
                                        alt="SOP">
                                    </div>
                                    <div class="card-task-content d-flex justify-content-between step-card align-items-start" [class.handDisinfy]="stepCards.hygieneRelevantStep">
                                        <p class="card-task-desc card-text">
                                            {{stepCards.stepTittle | translate | labelSanitizer}}</p>
                                        <div class="icons-div">

                                            <span *ngIf="seletedSteps[i] && seletedSteps[i][j]"
                                            [ngClass]="seletedSteps[i][j].swapped ? 'stepbg-swapped' : 'stepbg'">
                                            {{ seletedSteps[i][j]?.stepOrder }}</span>

                                            <span class="noSterlity" *ngIf="seletedSteps[i] && seletedSteps[i][j] && seletedSteps[i][j].noSterility"></span>
                                        </div>

                                    </div>

                                    <!-- <span class="step-count">{{(seletedSteps[i] && seletedSteps[i][j])?seletedSteps[i][j].stepOrder:''}}</span> -->
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>

            </div>
        </div>
    </div>
    <div class="col-12 m-0 ui-dialog-foot flexDirectionColumn">
      <div class="div-button-center  d-flex justify-content-end">
        <button type="button" class="btn-bd-empty warning center-button" *ngIf="!done && enableNosterility"
          (click)="noSterility()">
          <img class="separate-buttons" src="assets/icons/icon-warning-outline.svg" />
          <span>{{ translationKeys.SOPObservation.NoSterility | translate }}</span>
        </button>
        <button type="button" class="btn-bd-empty mx-4" (mouseover)="hovered=true" (mouseout)="hovered=false"
          (click)="openComment()">
          <span class="deskButton">{{ translationKeys.SOPObservation.Comment | translate }}</span> <span
            class="deskButton ml-1" *ngIf="comments && comments.length > 0">({{comments.length}})</span>
        </button>
        <button type="button" class="btn-bd" *ngIf="!done" (click)="submitData()" [disabled]="seletedSteps.length === 0">
          <span class="deskButton">{{ translationKeys.SOPObservation.CheckSteps | translate }}</span>
        </button>
        <button type="button" class="btn-bd" *ngIf="done" (click)="submitData(); $event.target.blur()"
          [disabled]="seletedSteps.length === 0">
          <span class="deskButton">{{ translationKeys.SOPObservation.SaveObservation | translate }}</span>
        </button>
      </div>
    </div>
</div>
<app-ph-bhp-observe-comments #observeComments [comments]="comments" [isCollapsed]="isCollapsed" [userData]="this.appConfig.userData" [institutions]="this.appConfig.institutions" [numberToName]="numberToName" [sopid]="sopDetail.sopid" (childData)="onchildData($event)">
</app-ph-bhp-observe-comments>
<ng-template #deselectStepModal>
    <div class="p-0 modal-header justify-content-between align-items-center ">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="newModalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="">
        <p class="lead">
            {{ 'SOP_OBSERVATION.CONFIRMATION.DESELECT_STEP' | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <div class="p-0 m-0">
            <div class="justify-content-end align-items-end d-flex">
                <button (click)="newModalRef.hide();" class="btn-cancel-bordered-bd">{{ 'AUTHORIZATION.CANCEL' | translate }}</button>
                <button (click)="deselectStep();newModalRef.hide()" class="btn-bd-empty ml-3">{{ 'LAYOUT_MODULE.DESELECT' | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #deselectfromCenterModel>
    <div class="p-0 modal-header justify-content-between align-items-center ">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="newModalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="">
        <p class="">
            {{ 'SOP_OBSERVATION.CONFIRMATION.DESELECT_STEP' | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <div class="p-2 container-fluid">
            <div class="justify-content-end align-items-end d-flex">
                <button (click)="newModalRef.hide();" class="btn-cancel-bordered-bd">{{ 'INSTITUTION_MANAGEMENT.NO' | translate }}</button>
                <button (click)="deselectfromCenter();newModalRef.hide()" class="btn-bd-empty ml-3">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #confirmationSOP>
    <div class="p-0 modal-header justify-content-between align-items-center">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="newModalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="" >
        <p class="">
            {{ 'SOP_OBSERVATION.CONFIRMATION.CLOSE_OBSERVATION_WITHOUT_SUBMITTING' | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <div class="p-2 container-fluid">
            <div class="justify-content-end align-items-end d-flex">
                <button (click)="newModalRef.hide()" class="btn-cancel-bordered-bd">{{ 'AUTHORIZATION.CANCEL' | translate }}</button>
                <button (click)="newModalRef.hide();modalRef.hide();" class="btn-bd-empty ml-3">{{ 'INSTITUTION_MANAGEMENT.CLOSE' | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>
